import { useStores } from 'hooks';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { GRAY, MessageCount, WHITE } from '../Styles';

export const ExpandCollapseDataButton = observer(() => {
  const {
    DebuggerStore: { logCount, logView, setDebugProperty },
  } = useStores();

  const isCollapsed = logView === 'collapsed';

  if (logCount === 0) return null;

  return (
    <MessageCount
      bgColor={GRAY}
      color={WHITE}
      onClick={() =>
        setDebugProperty('logView', isCollapsed ? 'expanded' : 'collapsed')
      }
      style={{
        cursor: 'pointer',
        borderRadius: '50%',
        width: '35px',
        height: '35px',
      }}
    >
      {isCollapsed ? '+' : '-'}
    </MessageCount>
  );
});

export default ExpandCollapseDataButton;
